module.exports = __webpack_public_path__ + "static/media/search_icon.b8614845.png";